import { Tab } from "@blueprintjs/core"
import React, { useEffect, useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import CustomVerticalTabs from "components/Organisms/CustomVerticalTabs"
import { BENCHMARK_CATEGORIES } from "data/static.items"
import { useBenchmarkRecommendations } from "graphql/benchmark.graphql.gql"
import VarietyBenchmarks from "./VarietyBenchmarks"
// import CustomVerticalTabs from "components/Organisms/CustomVerticalTabs";
// import { Tab } from "@blueprintjs/core";

interface ItemBenchmarkDialogProps {
  isOpen: boolean
  /**
   * The sellable item for which the benchmarks are to be shown
   * note: 1 sellable item can have many varieties and each variety has its own seperate benchmark rate
   */
  sellableItem: any
  onClose?: () => void
}
const ItemBenchmarkDialog = ({
  isOpen,
  onClose,
  sellableItem,
}: ItemBenchmarkDialogProps) => {
  const retailGroups = BENCHMARK_CATEGORIES.find(b =>
    /retail/i.test(b.name)
  )?.id?.split("|")

  const [commodityGroup, setCommodityGroup] = useState<any>(null)
  const { data } = useBenchmarkRecommendations(commodityGroup, retailGroups)

  const benchmarks = data?.allPriceBenchmarkRecommendations

  const varieties = sellableItem?.sellableVarieties

  useEffect(() => {
    if (varieties?.[0]) {
      setCommodityGroup(varieties[0].variety.primaryGroup?.id)
    }
  }, [varieties])

  const filteredVarieties = varieties?.filter(
    (v: any) => v?.variety?.primaryGroup
  )
  return (
    <CustomDialog
      onOpening={e => {
        // const sellableItemId = sellableItem?.id;
      }}
      icon="comparison"
      light
      width="45%"
      title={
        <span>
          <span className="vt-muted">Benchmark rates for -</span>
          <span> {sellableItem?.name} ( Retail )</span>
        </span>
      }
      isOpen={isOpen}
      onClose={onClose}
    >
      <CustomVerticalTabs
        large
        selectedTabId={commodityGroup}
        onChange={(item: string) => setCommodityGroup(item)}
        className="w-full"
        vertical
      >
        {filteredVarieties?.length > 0 ? (
          filteredVarieties?.map((v: any) => {
            const primaryGroup = v?.variety?.primaryGroup
            return (
              <Tab
                id={primaryGroup?.id}
                className="w-full"
                title={primaryGroup?.name ?? "Na"}
                panel={<VarietyBenchmarks benchmarks={benchmarks} />}
              />
            )
          })
        ) : (
          <p>No Valid variety groups found for the selected sellable items</p>
        )}
      </CustomVerticalTabs>
    </CustomDialog>
  )
}

export default ItemBenchmarkDialog
